export default __webpack_public_path__ + "static/media/ErrorPage.cee207ad.png";